
/**
 * GSC AUDIO SESSION MANAGER - V1.2 (Hardware Continuity Patch)
 */

let globalStream: MediaStream | null = null;
let activeUsers = 0;

export const AudioSessionManager = {
    async acquireStream(constraints: MediaStreamConstraints): Promise<MediaStream> {
        const needsVideo = !!constraints.video;
        const hasVideo = globalStream ? globalStream.getVideoTracks().length > 0 : false;

        // Si le flux actuel ne contient pas de vidéo alors qu'on en a besoin, on le ferme pour repartir à neuf
        if (globalStream && needsVideo && !hasVideo) {
            this.hardReset();
        }

        if (globalStream && globalStream.active) {
            activeUsers++;
            return globalStream;
        }

        try {
            globalStream = await navigator.mediaDevices.getUserMedia(constraints);
            activeUsers = 1;
            return globalStream;
        } catch (e) {
            globalStream = null;
            activeUsers = 0;
            throw e;
        }
    },

    releaseStream() {
        activeUsers--;
        if (activeUsers <= 0) {
            // Optionnel : ne pas fermer tout de suite pour éviter le délai de switch
        }
    },

    hardReset() {
        if (globalStream) {
            globalStream.getTracks().forEach(t => t.stop());
            globalStream = null;
        }
        activeUsers = 0;
    }
};
